<template>
  <v-container
    ctq
    fluid
    grid-list-xl
    pt-0
  >
    <v-layout wrap>
      <v-flex xs12>
        <material-card
          title="CTQ Daily Export"
          class="card-padding v-card__first"
          color="general"
        >
          <v-form>
            <v-container
              py-0
              class="mw-100">
              <v-layout wrap>
                <v-flex
                  flex-small
                  mt-3
                  xs12
                  sm6
                  lg2>
                  <v-autocomplete
                    v-model="summaryVendor"
                    :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                    :items="vendorMenu"
                    label="Vendor"
                    class="v-text-field__slot"
                    persistent-hint
                    outlined
                  />
                </v-flex>
                <v-flex
                  flex-small
                  mt-3
                  d-flex
                  align-items-center
                  xs12
                  lg2>
                  <p class="m-0 mr-2">File Date</p>
                     <v-menu
                    v-model="fileDateMenu"
                    :close-on-content-click="false"
                    :nudge-left="40"
                    lazy
                    transition="scale-transition"
                    max-width="290px"
                    offset-y
                    full-width
                  >
                    <v-text-field
                      slot="activator"
                      :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                      v-model="fileDate"
                      label=""
                      prepend-icon="event"
                    />
                    <v-date-picker
                      v-model="fileDate"
                      :min="startdate"
                      :max="maxDate"
                      :color="theme==='dark'?'danger':'general'"
                      type="date"
                      no-title
                      scrollable
                      actions/>
                  </v-menu>
                </v-flex>
                <v-flex
                  flex-small
                  mt-3
                  d-flex
                  align-items-center
                  xs12
                  lg6>
                  <p class="m-0 mr-2">Process Date</p>
                  <module-datepicker-datetime-field
                    v-model="processDateStart"
                    :min-date="startdate"
                    :max-date="maxDate"
                  />
                  <p class="m-0 text-center px-3">到</p>
                  <module-datepicker-datetime-field
                    v-model="processDateEnd"
                    :min-date="processEndMinDate"
                    :max-date="maxDate"
                  />
                </v-flex>
                <v-flex
                  flex-small
                  mt-3
                  xs12
                  sm6
                  lg1
                  text-xs-right
                  d-flex
                  align-items-center
                >
                  <v-btn
                    class="mx-0 font-weight-light"
                    color="general"
                    @click="doExport()"
                  >
                    <v-icon class="mr-2">mdi-export</v-icon>Export data
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </material-card>
      </v-flex>
    </v-layout>
    <v-dialog
      v-model="processingView"
      :width="'calc(100% - ' + shrink + 'px)'"
      class="chart-view"
      persistent>
      <p style="letter-spacing: 5px;text-align: center !important;color: #ffffff;background-color: #000000dd;padding: 15px;width: 50%;margin: auto;">
        <img
          :src="Loading"
          style="width: 2rem;margin-bottom: 10px;">
        <br>
        PROCESSING 處理中
      </p>
    </v-dialog>
    <v-snackbar
      v-model="snackbar"
      :top="true"
      :color="snackbarColor">
      {{ snackbarMsg }}
      <v-btn
        dark
        flat
        @click="snackbar = false">
        Close
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import qs from 'qs'
import { mapState } from 'vuex'
import Loading from '@/assets/img/loading.gif'

export default {
  name: 'CTQDailyExport',
  data () {
    return {
      snackbar: false,
      snackbarColor: 'red',
      snackbarMsg: '',
      Loading,
      processingView: false,
      startdate: '2018-04-01',
      fileDateMenu: false,
      summaryVendor: '',
      vendorMenu: [],
      fileDate: this.$moment(new Date()).format('YYYY-MM-DD'),
      processDateStart: this.$moment(new Date().getTime() - (3600000 * 24)).format('YYYY-MM-DD HH:mm:ss'),
      processDateEnd: this.$moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
    }
  },
  computed: {
    ...mapState('app', ['theme', 'shrink']),
    maxDate () {
      return this.$moment(new Date()).format('YYYY-MM-DD')
    },
    processEndMinDate () {
      if (!this.processDateStart) {
        return this.startdate
      }
      return this.$moment(this.processDateStart, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD')
    }
  },
  mounted () {
    this.$store.dispatch('getAuthorize', '/ctqdailyexport/CTQDailyExport')
      .then(response => {
        if (response.status === 'success' && response.data.accessible) {
          this.loadVendorMenu()
        } else if (response.errCode === 'E10000002') {
          const routeData = this.$router.resolve({ path: '/noEnter/E10000002' })
          localStorage.setItem('errormsg', response.errMsg)
          window.location.assign(routeData.href)
        } else {
          const routeData = this.$router.resolve({ path: JSON.parse(localStorage.getItem('user')).home })
          window.location.assign(routeData.href)
        }
      })
      .catch(err => {
        console.log(err)
        const routeData = this.$router.resolve({ path: JSON.parse(localStorage.getItem('user')).home })
        window.location.assign(routeData.href)
      })
  },
  methods: {
    loadVendorMenu () {
      const body = { type: 'mepart' }
      this.$http.get('/api/system/pmsPath/getCodeAndNameListByType?' + qs.stringify(body)).then(res => res.data)
        .then(res => {
          if (res.status === 'success') {
            this.vendorMenu = res.data.map(item => ({
              text: item.name,
              value: item.code
            }))
          }
        })
    },
    doExportVerification () {
      const start = new Date(this.processDateStart)
      const end = new Date(this.processDateEnd)

      // 開始日期 + 3 個月
      const maxEnd = new Date(start)
      maxEnd.setMonth(maxEnd.getMonth() + 3)
      if (this.summaryVendor === '') {
        this.snackbar = true
        this.snackbarColor = 'red'
        this.snackbarMsg = '請選擇 Vendor'
        return false
      }
      if (!this.fileDate) {
        this.snackbar = true
        this.snackbarColor = 'red'
        this.snackbarMsg = '請選擇 File Date'
        return false
      }
      if (!this.processDateStart) {
        this.snackbar = true
        this.snackbarColor = 'red'
        this.snackbarMsg = '請選擇 Process Date 起始時間'
        return false
      }
      if (!this.processDateEnd) {
        this.snackbar = true
        this.snackbarColor = 'red'
        this.snackbarMsg = '請選擇 Process Date 結束時間'
        return false
      }
      if (this.$moment(this.processDateEnd).isBefore(this.$moment(this.processDateStart))) {
        this.snackbar = true
        this.snackbarColor = 'red'
        this.snackbarMsg = 'Process Date 結束時間不可早於起始時間'
        return false
      }
      if (end > maxEnd) {
        this.snackbar = true
        this.snackbarColor = 'red'
        this.snackbarMsg = '日期範圍不能超過3個月'
        return false
      }
      return true
    },
    doExport () {
      if (!this.doExportVerification()) {
        return
      }

      const body = {
        vendorCode: this.summaryVendor,
        fileDate: this.fileDate,
        processStartTime: this.processDateStart,
        processEndTime: this.processDateEnd
      }

      this.processingView = true

      this.$http.post(
        '/api/ctq/daily/export/download',
        body,
        {
          responseType: 'blob'
        }
      )
        .then(res => {
          this.processingView = false
          console.info(res)
          const blob = res.data

          const url = window.URL.createObjectURL(blob)

          function formatDate () {
            const d = new Date()
            const pad = (n) => n.toString().padStart(2, '0')

            return (
              d.getFullYear() +
    pad(d.getMonth() + 1) +
    pad(d.getDate()) +
    '_' +
    pad(d.getHours()) +
    pad(d.getMinutes()) +
    pad(d.getSeconds())
            )
          }

          let filename = 'CTQ_daily_export_' + formatDate() + '.zip'

          const disposition = res.headers['content-disposition']
          if (disposition) {
            const match = disposition.match(/filename="?([^"]+)"?/)
            if (match && match[1]) {
              filename = match[1]
            }
          }

          const a = document.createElement('a')
          a.href = url
          a.download = filename

          document.body.appendChild(a)
          a.click()

          document.body.removeChild(a)
          window.URL.revokeObjectURL(url)

          this.snackbar = true
          this.snackbarColor = 'success'
          this.snackbarMsg = '下載成功'
        })
        .catch(async err => {
          this.processingView = false

          let msg = '下載失敗'

          if (err.response && err.response.data) {
            try {
              msg = await err.response.data.text()
            } catch (e) {
            }
          }

          this.snackbar = true
          this.snackbarColor = 'orange'
          this.snackbarMsg = msg
        })
    }
  }
}
</script>
